import { render } from "./EditWasteCar.vue?vue&type=template&id=2f77a8d0&scoped=true"
import script from "./EditWasteCar.vue?vue&type=script&lang=js"
export * from "./EditWasteCar.vue?vue&type=script&lang=js"

import "./EditWasteCar.vue?vue&type=style&index=0&id=2f77a8d0&scoped=true&lang=css"

import exportComponent from "/home/le01s/projects/amlogger/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f77a8d0"]])

export default __exports__